// TwoFactorAuth.js
import React, { useState, useEffect } from "react";
import { Button } from "./ui";
import { MDBContainer, MDBCard, MDBCardBody, MDBCardImage, MDBInput, MDBRow, MDBCol } from "mdb-react-ui-kit";
import { api } from "../services";
import { useTranslation } from "react-i18next";

function TwoFactorAuth() {
  const { t } = useTranslation("translation");
  const [qrCode, setQrCode] = useState("");
  const [secret, setSecret] = useState("");
  const [token, setToken] = useState("");
  const [setupCompleted, setSetupCompleted] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    const setup2FA = async () => {
      try {
        const response = await api.post("/2fa/setup");
        setQrCode(response.data.qrCodeDataURL);
        setSecret(response.data.secret);
      } catch (error) {
        setError(t("Failed to generate 2FA QR Code."));
        console.error("Error setting up 2FA:", error);
      }
    };
    setup2FA();
  }, [t]);

  const handleVerify = async () => {
    try {
      const response = await api.post("/2fa/verify", { token });
      setMessage(response.data.message);
      setSetupCompleted(true); // Mark setup as complete if successful
      setError("");
    } catch (error) {
      setError(t("Invalid 2FA token."));
      setMessage("");
      console.error("Error verifying 2FA:", error);
    }
  };

  return (
    <>
      <MDBContainer fluid className="p-4 content-area">
        <MDBRow className="justify-content-center">
          <MDBCol md="6">
            <MDBCard>
              <MDBCardBody>
                <h3>Two-Factor Authentication</h3>
                {error && <p className="text-danger">{error}</p>}
                {message && <p className="text-success">{message}</p>}

                {!setupCompleted ? (
                  <>
                    <div className="mb-4">
                      <h5>Step 1: Setup 2FA</h5>
                      {qrCode && (
                        <>
                          <p>Scan the QR code with your authenticator app:</p>
                          <MDBCardImage
                            src={qrCode}
                            alt="QR Code"
                            className="img-fluid mb-3"
                          />
                          <p>
                            <strong>Secret:</strong> {secret}
                          </p>
                        </>
                      )}
                    </div>
                    <div className="mb-4">
                      <h5>Step 2: Verify 2FA</h5>
                      <MDBInput
                        label="Enter 2FA Code"
                        type="text"
                        value={token}
                        onChange={(e) => setToken(e.target.value)}
                        wrapperClass="mb-4"
                      />
                      <Button onClick={handleVerify}>Verify</Button>
                    </div>
                  </>
                ) : (
                  <p className="text-success">
                    Two-Factor Authentication setup completed successfully!
                  </p>
                )}
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </>
  );
}

export default TwoFactorAuth;
